const documentErrorTypes = {
  validSignatureReadable: 'signature is not readable',
  validName: 'name is not valid',
  validFlightNumber: 'flight number is not valid',
  validDateAndTimeDeparture: 'departure date or time is not valid',
  validDateAndTimeArrival: 'arrival date or time is not valid',
  validOperatingAirline: 'operating airline is not valid',
  validTrip: 'trip is not valid',
  validNameOfPax : 'name of the pax is not valid',
  validAmount : 'amount is not valid'
}

export default documentErrorTypes


// WEBPACK FOOTER //
// ./src/utils/documentErrorTypes.js